import React from 'react';
import { Link } from 'react-router-dom';

// ---------------------------------------------------------------------------
// Página pública de vagas — o rosto do domínio para candidatos
// ---------------------------------------------------------------------------
// ⚠️ É um iframe de TELA CHEIA (100vw × 100vh). Até 2026-08-04 isso a tornava um
//    BECO SEM SAÍDA: quem do portal caísse aqui — atalho de tela inicial abrindo
//    a raiz, sessão vencida — não tinha nenhum caminho para o login, porque o
//    iframe cobre a viewport inteira e a página não tem cabeçalho próprio.
//    Daí o link flutuante abaixo: discreto para o candidato, suficiente para
//    quem é da casa.

const Vagas = () => {
    const canvaEmbedLink = "https://www.canva.com/design/DAHDeGaDImo/FnVJdixLgoW7LhbgNoaCpA/view?embed";

    return (
        <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
            {/* Acesso ao portal — flutua sobre o iframe (que não deixa espaço a
                mais). z-index alto porque o embed do Canva cria contexto próprio. */}
            <Link
                to="/login"
                style={{
                    position: 'fixed', top: '14px', right: '14px', zIndex: 2147483647,
                    display: 'inline-flex', alignItems: 'center', gap: '7px',
                    padding: '9px 16px', borderRadius: '999px', textDecoration: 'none',
                    backgroundColor: 'rgba(15, 23, 42, 0.86)', color: '#fff',
                    fontFamily: "'Raleway', sans-serif", fontSize: '13px', fontWeight: 700,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.25)', backdropFilter: 'blur(4px)',
                }}
            >
                Acessar o portal
            </Link>

            <iframe 
                src={canvaEmbedLink}
                style={{ 
                    width: '100%', 
                    height: '100%', 
                    border: 'none',
                    margin: 0,
                    padding: 0,
                    display: 'block'
                }}
                title="Página de Vagas - Grupo Correia"
                allowFullScreen
            ></iframe>
        </div>
    );
};

export default Vagas;